export default "__VITE_PUBLIC_ASSET__0d41eb68__"